module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/5chap1#chap1"
    }
  }, [_vm._v("I. The End of an Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/6chap2#chap2"
    }
  }, [_vm._v("II. A Patient’s Subsconscious")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/7chap3#chap3"
    }
  }, [_vm._v("III. “I Understand Him too Well!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/8chap4#chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. “If He Dies—”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/9chap5#chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. Is a Woman Surgeon Still a Woman?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/10chap6#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. No Longer Her Patient")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11chap7#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. A Hospital Christmas—and a Kiss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12chap8#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. In the Doctor’s Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13chap9#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX. A Part in a Play")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14chap10#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X. Lifted Out of Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15chap11#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI. Betrayed to the Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/16chap12#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII. Night and the First Beloved")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/17chap13#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII. Clandestine Romance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/18chap14#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV. There’s No Substitute for Living")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/19chap15#chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV. A Shattering Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/20chap16#chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI. A Night to Remember")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/21chap17#chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII. Village Gossip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/22chap18#chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII. A Long-Kept Secret")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/23chap19#chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX. Into the Light")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/24biography#biography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Mary Renault")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18933387","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3TOC.vue
// module id = 69
// module chunks = 0